import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

// import { DocumentTypesList } from 'entities/user/module'
import { IScanDocument } from 'shared/api/scan-document'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import ScanDocumentIcon from 'shared/images/info.png'
import { showWrongDateFormat } from 'shared/lib/dateFormat'
import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

type Props = {
  data: IScanDocument
  onContinue?: () => void
  onTryAgainScan?: () => void
}

export const DialogScanPassport = ({
  data,
  onContinue,
  onTryAgainScan,
}: Props) => {
  const { t } = useTranslation()

  const { closeDialog } = useDialogBottomSheet()

  // const currentTypeDocument = DocumentTypesList.find(
  //   (type) => type.key === String(data.document_type),
  // )

  const list = [
    {
      name: t('last_name'),
      value: data.last_name || '-',
    },
    {
      name: t('first_name'),
      value: data.first_name || '-',
    },
    {
      name: t('birth_day'),
      value:
        showWrongDateFormat(
          data.date_of_birth || '',
          DATE_FORMAT_LIST.FULL_DATE_WITH_MONTH_STAND_ALONE,
        ) || '-',
    },
    // {
    //   name: t('gender'),
    //   value: data.gender ? t(data.gender) : '-',
    // },
    {
      name: t('citizenship'),
      value: data.citizenship?.name?.toUpperCase() || '-',
    },
    // {
    //   name: t('type_passport'),
    //   value: currentTypeDocument ? t(currentTypeDocument?.name) : '-',
    // },
    // {
    //   name: t('serial_documents'),
    //   value: data.id_card_number || '-',
    // },
    // {
    //   name: t('expiration_date'),
    //   value:
    //     showWrongDateFormat(
    //       data.id_card_expire || '',
    //       DATE_FORMAT_LIST.FULL_DATE_WITH_MONTH_STAND_ALONE,
    //     ) || '-',
    // },
  ]

  const onSubmit = () => {
    onContinue?.()
    closeDialog()
  }

  const onTryAgain = () => {
    closeDialog()
    onTryAgainScan?.()
  }

  return (
    <div className={s.dialogScanPassport}>
      <ImageLazy
        src={ScanDocumentIcon}
        className={s.icon}
        alt="info"
      />
      <div className={s.text}>
        <h2 className={clsx(s.title, 'bold-20')}>
          {t('scan_passport.check_your_data')}
        </h2>
      </div>

      <ul className={s.list}>
        {list.map((item) => (
          <li
            key={nanoid()}
            className={clsx(s.item, 'medium-14')}
          >
            <span className={clsx(s.name, 'regular-14')}>{item.name}</span>:{' '}
            {item.value}
          </li>
        ))}
      </ul>

      <div className={s.button_container}>
        <Button onClick={onSubmit}>
          <span className={clsx(s.textButton, s.black, 'semi-bold-17')}>
            Ок
          </span>
        </Button>

        <Button
          onClick={onTryAgain}
          variant="transparentBlue"
        >
          <span className={clsx(s.textButton, s.blue, 'semi-bold-17')}>
            {t('one_more')}
          </span>
        </Button>
      </div>
    </div>
  )
}
